var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import createSvgLabel from "../create-svg-label/create-svg-label";
import offsetCenter from "../offset-center/offset-center";
var SlidingMarker = require("marker-animate-unobtrusive");
/**
 * LabelMarker is a class that takes a map, starting position, and label size
 * and will render a Marker as a label. This allows for keeping the same
 * position on the map and relative to other Google Map elements by using
 * LatLngs. Markers also don't resize bigger/smaller based on zoom it's pointing
 * to a single location. This makes it good so you can zoom in and out on a map
 * and the label is always in the same location.
 *
 * This Class specifically will also handle offsetting the label position to
 * keep it away from the mouse as you draw and when zooming in or out will
 * reposition it. In addition it will try to always force the text provided into
 * the label size you give it.
 */
var LabelMarker = /** @class */ (function (_super) {
    __extends(LabelMarker, _super);
    /**
     * Creates a new instance of a LabelMarker.
     * @param {google.maps.Map} map The map instance to put the label
     * @param {google.maps.LatLng} position The starting position for your label
     * @param {LabelMarkerSize} size The width and height you want to make the
     *   label. It will try to keep the text within these dimensions.
     */
    function LabelMarker(_a) {
        var map = _a.map, position = _a.position, size = _a.size;
        var _this = _super.call(this) || this;
        _this._marker = new SlidingMarker({
            map: map,
            position: position,
            duration: 1,
            // Put it above other markers since it's a label
            zIndex: 999,
        });
        //adds overlay to map
        _this.setMap(map);
        _this._map = map;
        _this._size = size;
        _this._cachedLastPosition = position;
        _this._startPosition = position;
        _this._addZoomListener();
        return _this;
    }
    LabelMarker.prototype.onRemove = function () { };
    LabelMarker.prototype.pushLabelToFloatPane = function () {
        console.log("Pushing label to floatPane");
        var panes = this.getPanes();
        var markerLayerNode = panes === null || panes === void 0 ? void 0 : panes.markerLayer.parentElement;
        if (markerLayerNode) {
            setTimeout(function () {
                var labelMarkerImg = markerLayerNode.querySelectorAll('div div[style*="z-index: 999"] img')[0];
                if (labelMarkerImg && labelMarkerImg.parentElement) {
                    var parent_1 = labelMarkerImg.parentElement;
                    parent_1.classList.add("distance-label-marker");
                    panes === null || panes === void 0 ? void 0 : panes.floatPane.append(labelMarkerImg.parentElement);
                    console.log("Pushed label to floatPane");
                }
            }, 100);
        }
    };
    /**
     * Overlay onAdd method.
     * Called when this.setMap() is called.
     */
    LabelMarker.prototype.onAdd = function () {
        this.pushLabelToFloatPane();
    };
    /**
     * Call this method to render the marker onto the map. It takes text which
     * will be rendered into the label. Call this whenever you want to change
     * the label text.
     *
     * @param {string} text The text to render into the label.
     */
    LabelMarker.prototype.render = function (text) {
        this._marker.setIcon(createSvgLabel({
            text: text,
            width: this._size.width,
            height: this._size.height,
        }));
    };
    /**
     * Puts the label at the given LatLng. It will automatically offset it away
     * from the cursor and will keep it in the right place as you zoom in/out.
     *
     * @param {google.maps.LatLng} latLng The LatLng to place the label.
     */
    LabelMarker.prototype.setPosition = function (latLng, drawingManagerMode) {
        var newLng = latLng.lng();
        var newLat = latLng.lat();
        var startLng = this._startPosition.lng();
        var startLat = this._startPosition.lat();
        var xDirection = newLng > startLng ? "right" : "left";
        var yDirection = newLat > startLat ? "up" : "down";
        var yOffset = 0;
        var xOffset = 0;
        if (drawingManagerMode === "rectangle") {
            if (yDirection === "up") {
                yOffset = this._size.height;
            }
            else {
                yOffset = 0;
            }
            if (xDirection === "left") {
                xOffset = -(this._size.width / 2);
            }
            else {
                xOffset = this._size.width / 2;
            }
        }
        else if (drawingManagerMode === "ruler") {
            if (xDirection === "left") {
                xOffset = this._size.width / 2 + 5;
            }
            else {
                xOffset = -(this._size.width / 2) - 5;
            }
        }
        else if (drawingManagerMode === "circle") {
            if (xDirection === "left") {
                xOffset = this._size.width / 2 + 5;
            }
            else {
                xOffset = -(this._size.width / 2) - 5;
            }
            if (yDirection === "down") {
                yOffset = this._size.height;
            }
        }
        this._cachedLastPosition = latLng;
        this._marker.setPosition(offsetCenter(this._map, latLng, xOffset, yOffset));
    };
    /**
     * Removes the label from the map.
     */
    LabelMarker.prototype.remove = function () {
        google.maps.event.removeListener(this._zoomHandler);
        this._marker.setMap(null);
        this.setMap(null);
    };
    /**
     * Sets up the zoom listener so that when you zoom in and out it will
     * reposition the marker so it makes sense still considering the offsets.
     * Since offsets are based on pixels, without this, as you zoom in and out
     * it will *appear* that the marker isn't in the same place.
     *
     * It also adds a little duration so the marker doesn't snap into place when
     * the zoom in/out repositioning happens. Instead it slides into the new
     * placement.
     *
     * @private
     */
    LabelMarker.prototype._addZoomListener = function () {
        var _this = this;
        this._zoomHandler = google.maps.event.addListener(this._map, "zoom_changed", function () {
            // @ts-ignore because it's mixed in with SlidingMarker
            _this._marker.setDuration(500);
            _this.setPosition(_this._cachedLastPosition, window.batchGeoDrawingManager.getDrawingMode());
            // @ts-ignore because it's mixed in with SlidingMarker
            _this._marker.setDuration(0);
        });
    };
    return LabelMarker;
}(google.maps.OverlayView));
export default LabelMarker;
